import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { FaFile } from 'react-icons/fa6'
import { useDisclosure } from '@chakra-ui/react'
import { Box, Text, Center } from '@chakra-ui/react'

import { AttachmentItemProps } from '.'
import RemoveAttachmentButton from './remove-button'
import FullScreenPreview from './full-screen-preview'

export default function PdfAttachment({
    attachment,
    onRemove,
}: AttachmentItemProps) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            <Box
                position="relative"
                h="full"
                bg="gray.100"
                aspectRatio={0.78}
                borderRadius="lg"
                role="group"
                overflow="hidden"
                cursor="pointer"
            >
                <Center w="full" h="full" flexDir="column" gridGap={4}>
                    <Icon as={FaFile} fontSize="5xl" color="gray.300" />
                    <Text fontSize="xs" color="gray.400" fontWeight="medium">
                        {attachment.filename}
                    </Text>
                </Center>
                <Box
                    position="absolute"
                    top={0}
                    right={0}
                    bottom={0}
                    left={0}
                    _groupHover={{ bg: 'blackAlpha.200' }}
                    onClick={onOpen}
                />
                {onRemove && <RemoveAttachmentButton onClick={onRemove} />}
            </Box>
            <FullScreenPreview
                attachment={attachment}
                isOpen={isOpen}
                onClose={onClose}
                showDownload={true}
            />
        </>
    )
}
